import { Button, Card, Grid, Typography } from "@mui/material";
import DataTable from "../../../components/DataTable";
import { useEffect, useReducer, useState } from "react";
import { TRAY_APIS } from "../../../common/apis";
import useFetch from "../../../hooks/useFetch";
import Form, { FormActions } from "../../../components/Form";
import { ExcelIcon } from "../../../icons/ButtonIcons";
import renderCellExpand from "../../../components/DatatableCellExpand";
import { toLocalDate2 } from "../../../utils";

const UnitsRecentSamples = ({ formData }) => {
  const { post, postFile } = useFetch();

  const [unitsRecentList, setUnitsRecentList] = useState([]);
  const [localData, setLocalData] = useState({});

  const [filterData, dispatch] = useReducer(
    RegistrationFilterReducer,
    RegistrationFilterDefaults
  );

  const handleView = async (le) => {
    const dataList = await post(`${TRAY_APIS.UNIT_SAMPLE_REPORT}`, {
      ProductId: formData?.ProductId || localData?.ProductId || le?.ProductId,
      CustomerId: formData?.CustomerId || localData?.CustomerId || le?.CustomerId,
      ParentId: formData?.ParentId || localData?.ParentId || le?.ParentId,
      SiteId: formData?.SiteId || localData?.SiteId || le?.SiteId,
      UnitId: formData?.UnitId || localData?.UnitId || le?.UnitId,
      Date1: filterData?.date,
    });
    setUnitsRecentList(dataList);
  };

  const getExcelFile = async () => {
    await postFile(
      TRAY_APIS.EXPORT_UNIT_SAMPLE_REPORT,
      {
        ProductId: formData?.ProductId || localData?.ProductId,
        CustomerId: formData?.CustomerId || localData?.CustomerId,
        ParentId: formData?.ParentId || localData?.ParentId,
        SiteId: formData?.SiteId || localData?.SiteId,
        UnitId: formData?.UnitId || localData?.UnitId,
        Date1: filterData?.date,
      },
      "Units With No Recent Samples"
    );
  };

  useEffect(() => {
    let le = JSON.parse(localStorage.getItem("units-no-recent-samples"))
    if (le?.UnitId > 0) {
      setLocalData(le);
      handleView(le)
    } else {
      handleView();
    }
  }, []);

  const rowSelected = () => { };

  const options = {
    dataSource: (unitsRecentList || []).map((x) => ({
      ...x,
      keyProp: x.CustomerId + "" + (x.SiteId || "") + (x.UnitId || ""),
    })),
    rowIdProperty: "keyProp",
    isDisableColumnFilter: false,
    cellStylingHandler: "componentRecentSamples",
    rowsSelected: function (r) {
      r.length && rowSelected(r[0]);
    },
    sx: { height: 500 },
  };

  return (
    <>
      <Grid container spacing={2} minWidth={"90vw"} mb={1}>
        <Grid item xs={12}>
          <Card sx={{ p: 1 }}>
            <Form
              sections={GetFormSections(
                unitsRecentList,
                handleView,
                getExcelFile
              )}
              data={filterData}
              spacing={2}
              dispatch={dispatch}
              key={filterData._ts_key || ""}
            />
          </Card>
        </Grid>
      </Grid>

      <Typography>
        {unitsRecentList?.length} units(s) were found with no approved samples
        or last approved sample before the selected date
      </Typography>
      <DataTable {...options} columns={GetColumns()} />
    </>
  );
};

export default UnitsRecentSamples;

function GetFormSections(unitsRecentList, handleView, getExcelFile) {
  return [
    {
      fields: [
        {
          name: "date",
          label: "Last Sampled Before",
          type: "date",
          xsCol: 3,
          disableFuture: "true",
        },
        {
          alignSelf: "flex-end",
          component: function () {
            return (
              <Button
                variant="contained"
                onClick={handleView}
              //   startIcon={<SearchIcon />}
              >
                View
              </Button>
            );
          },
        },
        {
          alignSelf: "flex-end",
          component: function () {
            return (
              <Button
                variant="outlined"
                onClick={getExcelFile}
                startIcon={<ExcelIcon />}
                disabled={unitsRecentList?.length < 1}
              >
                Excel
              </Button>
            );
          },
        },
      ],
    },
  ];
}

const GetColumns = (tableActions) => [
  {
    headerName: "Product",
    field: "Product",
    width: 100,
    renderCell: renderCellExpand,
  },
  {
    headerName: "Customer",
    field: "Customer",
    width: 150,
    flex: 1,
    renderCell: renderCellExpand,
  },
  {
    headerName: "Site",
    field: "Site",
    width: 250,
    renderCell: renderCellExpand,
  },
  {
    headerName: "Unit",
    field: "Unit",
    width: 100,
    renderCell: renderCellExpand,
  },
  {
    headerName: "Sampled",
    field: "LastSampled",
    width: 100,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },
  {
    headerName: "Received",
    field: "LastReceived",
    width: 100,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },

  {
    headerName: "Count",
    field: "SampleCount",
    valueFormatter: ({ value }) => (value > 0 ? value : 0),
    width: 100,
  },
  {
    headerName: "Created",
    field: "UnitCreated",
    valueFormatter: ({ value }) => toLocalDate2(value),
    width: 100,
  },
];

function RegistrationFilterReducer(state, action) {
  if (action.type === FormActions.INPUT_CHANGED) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  return state;
}

const RegistrationFilterDefaults = {
  date: new Date(),
};
